import Barcode from "react-barcode";
import QRCode from "react-qr-code";
import { InitialData } from "../types";

type QrCodeBarCodeDisplayProps = {
    data: InitialData;
    used: boolean;
    isExpired: boolean;
};


const QrCodeBarCodeDisplay = ({ data, used, isExpired }: QrCodeBarCodeDisplayProps) => {

    const lineColor = (used || isExpired) ? "#DADADA" : "#42436A";

    const barcodeElement = (isBarcodeAndQrcode = false) => {
        return isBarcodeAndQrcode ? (
            <Barcode
                value={data?.coupon_code ?? ""}
                marginBottom={20}
                displayValue={false}
                lineColor={lineColor}
                width={1.4}
                height={70}
            />
        ) : (
            <Barcode
                value={data?.coupon_code ?? ""}
                marginBottom={40}
                marginTop={50}
                displayValue={false}
                lineColor={lineColor}
                width={((data.coupon_code && data.coupon_code.length > 10) ? 1.4 : 1.8)}
                height={100}
            />
        );
    };

    const qrcodeElement = () => {
        return (
            <QRCode
                size={172}
                value={data?.coupon_code ?? ""}
                viewBox={"0 0 256 256"}
                fgColor={lineColor}
            />
        );
    };

    switch (data?.coupon_used_option) {
        case "BARCODE":
            return barcodeElement();
        case "QRCODE":
            return qrcodeElement();
        case "BARCODE_QRCODE":
            return (
                <>
                    {barcodeElement(true)}
                    {qrcodeElement()}
                </>
            );
        default:
            return null;
    }
};

export default QrCodeBarCodeDisplay;
